/* Ability Warehouse — interactive buying guide (vanilla, no dependencies).
   - TOC (sticky rail / collapsible strip), reading progress, jump-to-picks, sticky mobile bar
   - Add to cart: one /cart/add.js request that also returns the re-rendered cart drawer, applied through the
     theme's window.CWCart (count bump) — the reader stays in the guide and gets a toast instead of a drawer
   - Calculators read the live fit.* data printed by the section (never estimated)
   - Sortable comparison tables
   - "Let us help you find it": an in-guide chooser that asks the same questions as the collection chooser
     (assets/aw-choose.json), shortlists this guide's products, then hands the answers to the collection page as
     ?hmc=… — assets/aw-choose.js applies them there on arrival. */
(function () {
  'use strict';
  var root = document.querySelector('[data-guide]');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  /* ---------------------------------------------------------- header offset */
  function syncHeader() {
    var hh = 0;
    var h = document.querySelector('.shopify-section-header, header.header, .header');
    if (h) {
      var cs = getComputedStyle(h.closest('.shopify-section') || h);
      var r = h.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && r.height) hh = r.height;
    }
    if (!hh) { var cv = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10); if (cv) hh = cv; }
    root.style.setProperty('--g-header-h', (hh || 0) + 'px');
  }
  syncHeader();
  window.addEventListener('resize', syncHeader, { passive: true });
  window.addEventListener('load', syncHeader);

  /* ------------------------------------------------------------------- TOC */
  var toc = root.querySelector('[data-toc]');
  var sections = $$('[data-section]');
  var links = toc ? $$('a[data-toc-link]', toc) : [];
  var linkById = {};
  links.forEach(function (a) { linkById[a.getAttribute('href').slice(1)] = a; });
  if ('IntersectionObserver' in window && sections.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (a) { a.classList.remove('is-active'); a.removeAttribute('aria-current'); });
        var a = linkById[en.target.id];
        if (a) {
          a.classList.add('is-active'); a.setAttribute('aria-current', 'true');
          var ol = a.closest('ol');
          if (ol && ol.scrollWidth > ol.clientWidth + 4) ol.scrollTo({ left: a.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
    sections.forEach(function (s) { io.observe(s); });
  }
  var tocToggle = root.querySelector('[data-toc-toggle]');
  function setToc(open) { if (!toc || !tocToggle) return; toc.setAttribute('data-open', open ? 'true' : 'false'); tocToggle.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  if (tocToggle) tocToggle.addEventListener('click', function () { setToc(toc.getAttribute('data-open') !== 'true'); });
  function scrollToEl(el) {
    var top = el.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(root).getPropertyValue('--g-header-h'), 10) || 0) - (window.innerWidth < 990 ? 64 : 16);
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      setToc(false);
      scrollToEl(t);
      history.replaceState(null, '', a.getAttribute('href'));
    });
  });

  /* Reading progress */
  var progress = root.querySelector('[data-progress] i');
  var body = root.querySelector('[data-guide-body]') || root;
  if (progress) {
    var ticking = false;
    var paint = function () {
      ticking = false;
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var done = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
      progress.style.transform = 'scaleX(' + done.toFixed(3) + ')';
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  /* --------------------------------------------------------------- toast */
  var toastEl = root.querySelector('[data-guide-toast]');
  var toastTimer;
  function toast(html, type) {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.className = 'guide__toast' + (type ? ' guide__toast--' + type : '');
    toastEl.innerHTML = html;
    toastEl.hidden = false;
    void toastEl.offsetWidth;
    toastEl.classList.add('is-shown');
    toastTimer = setTimeout(hideToast, type === 'error' ? 7000 : 5500);
  }
  function hideToast() { if (!toastEl) return; toastEl.classList.remove('is-shown'); setTimeout(function () { toastEl.hidden = true; }, 250); }
  if (toastEl) {
    toastEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-toast-x]')) hideToast();
      if (e.target.closest('[data-cart-open]')) hideToast();
    });
    toastEl.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
    toastEl.addEventListener('mouseleave', function () { toastTimer = setTimeout(hideToast, 3000); });
  }

  /* --------------------------------------------------------- add to cart */
  function bumpCount(n) {
    document.querySelectorAll('.header__cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      var c = a.querySelector('.header__count');
      if (!c) { c = document.createElement('span'); c.className = 'header__count'; a.appendChild(c); }
      c.textContent = n;
      c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
  }
  function addToCart(vid, btn) {
    vid = String(vid || '').replace(/[^0-9]/g, '');
    if (!vid) return;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    var C = window.CWCart;
    var payload = { items: [{ id: +vid, quantity: 1 }] };
    if (C && C.sections) payload.sections = C.sections();
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Sorry, that could not be added.');
        var item = (res.j.items && res.j.items[0]) || res.j;
        var done = function () {
          toast('<span class="guide__toast-tick" aria-hidden="true">✓</span><span class="guide__toast-msg">Added <b>' + esc(item.product_title || 'item') + '</b> to your cart</span>' +
                '<button type="button" class="guide__toast-btn" data-cart-open>View cart</button>' +
                '<button type="button" class="guide__toast-x" data-toast-x aria-label="Dismiss">×</button>', 'ok');
          if (btn) { btn.classList.add('is-added'); btn.textContent = 'Added ✓'; setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 2200); }
        };
        if (C && C.apply && res.j.sections) return C.apply(res.j.sections).catch(function () {}).then(done);
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { bumpCount(c.item_count); }).catch(function () {}).then(done);
      })
      .catch(function (err) {
        toast('<span class="guide__toast-msg">' + esc(err.message) + '</span><button type="button" class="guide__toast-x" data-toast-x aria-label="Dismiss">×</button>', 'error');
        if (btn) btn.innerHTML = label;
      })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-guide-add]')) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]');
    addToCart(id && id.value, e.submitter || f.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-dyn]');
    if (!b || b.disabled) return;
    e.preventDefault();
    addToCart(b.getAttribute('data-vid'), b);
  });

  /* -------------------------------------------------------- product data */
  var PRODUCTS = {}, PLIST = [];
  var dataEl = root.querySelector('[data-guide-products]');
  if (dataEl) { try { PLIST = JSON.parse(dataEl.textContent); PLIST.forEach(function (p) { PRODUCTS[p.handle] = p; }); } catch (err) { PLIST = []; } }

  function priceLine(p) { return p.price_money ? esc(p.price_money) + (p.member_save ? ' <span class="gcm__mem">Members save ' + esc(p.member_save) + '</span>' : '') : ''; }
  function addBtn(p, small) {
    if (p.available && p.vid) return '<button type="button" class="gcm__add" data-add-dyn data-vid="' + esc(p.vid) + '" aria-label="Add ' + esc(p.title) + ' to cart">' + (small ? 'Add' : 'Add to cart') + '</button>';
    return '<a class="gcm__add gcm__add--ghost" href="' + esc(p.url) + '">' + (p.vid ? 'Sold out · view' : 'View') + '</a>';
  }

  /* --------------------------------------------------------- calculators */
  $$('[data-calc]').forEach(function (calc) {
    var kind = calc.getAttribute('data-calc');
    var handles = (calc.getAttribute('data-handles') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var range = calc.querySelector('input[type="range"]');
    var num = calc.querySelector('[data-calc-input]');
    var out = calc.querySelector('[data-calc-out]');
    if (!range || !num || !out) return;
    var fmt = function (n) { return (Math.round(n * 10) / 10).toString(); };

    function compute() {
      var val = parseFloat(num.value);
      if (isNaN(val) || val < +num.min || val > +num.max) { out.innerHTML = '<p class="guide__calc-note">Enter a measurement between ' + num.min + ' and ' + num.max + ' cm.</p>'; return; }
      var reco = '', recoSub = '', rows = [];
      if (kind === 'handle_height') {
        reco = 'Set the handles to about ' + fmt(val) + ' cm';
        recoSub = 'Stand tall, arms relaxed — handles at wrist height. Your elbows should have a soft bend. Between notches? Take the lower one.';
      } else if (kind === 'seat_height') {
        reco = 'A seat around ' + fmt(val - 1) + '–' + fmt(val + 2) + ' cm';
        recoSub = 'Feet flat on the floor, knees about level with the hips. Allow a little for the shoes you usually wear.';
      } else if (kind === 'doorway') {
        reco = 'Look for an overall width of ' + fmt(Math.max(0, val - 4)) + ' cm or less';
        recoSub = 'A product fits if it’s at least 4 cm narrower than the doorway — that leaves room for hands and knuckles on the wheels or grips.';
      }
      handles.forEach(function (h) {
        var p = PRODUCTS[h]; if (!p) return;
        var f = p.fit || {}, state = 'unknown', note = '';
        if (kind === 'handle_height' && f.handle_height_min_cm != null && f.handle_height_max_cm != null) {
          state = val >= f.handle_height_min_cm && val <= f.handle_height_max_cm ? 'fit' : 'no';
          note = 'Handles ' + fmt(f.handle_height_min_cm) + '–' + fmt(f.handle_height_max_cm) + ' cm';
          if (state === 'no') note += val < f.handle_height_min_cm ? ' · won’t go low enough' : ' · won’t go high enough';
        } else if (kind === 'seat_height' && f.seat_height_min_cm != null && f.seat_height_max_cm != null) {
          state = val + 2 >= f.seat_height_min_cm && val - 1 <= f.seat_height_max_cm ? 'fit' : 'no';
          note = 'Seat adjusts ' + fmt(f.seat_height_min_cm) + '–' + fmt(f.seat_height_max_cm) + ' cm';
        } else if (kind === 'seat_height' && f.seat_height_cm != null) {
          var d = f.seat_height_cm - val;
          state = d >= -1 && d <= 3 ? 'fit' : 'no';
          note = 'Seat ' + fmt(f.seat_height_cm) + ' cm' + (state === 'no' ? (d > 0 ? ' · higher than ideal for you' : ' · lower than ideal for you') : '');
        } else if (kind === 'doorway' && f.overall_width_cm != null) {
          state = f.overall_width_cm <= val - 4 ? 'fit' : 'no';
          note = fmt(f.overall_width_cm) + ' cm wide' + (state === 'no' ? ' · too wide for this doorway' : '');
        }
        if (state !== 'unknown' && f.confidence === 'partial' && f.source === 'legacy-spec-metafield') note += ' (to confirm)';
        rows.push({ p: p, state: state, note: note });
      });
      var order = { fit: 0, unknown: 1, no: 2 };
      rows.sort(function (a, b) { return order[a.state] - order[b.state]; });
      var nFit = rows.filter(function (r) { return r.state === 'fit'; }).length;
      var html = '<div class="guide__calc-reco"><b>' + esc(reco) + '</b><p>' + esc(recoSub) + '</p></div>';
      if (rows.length) {
        html += '<p class="guide__calc-sum">' + (nFit ? nFit + ' of the ' + rows.length + ' models in this guide ' + (kind === 'doorway' ? (nFit === 1 ? 'fits' : 'fit') + ' through that doorway' : (nFit === 1 ? 'suits' : 'suit') + ' that measurement') : 'None of the models in this guide quite suit that measurement — ask us and we’ll find one that does') + '</p>';
        html += '<div class="guide__calc-matches">';
        rows.forEach(function (m) {
          var p = m.p, cls = m.state === 'fit' ? 'is-fit' : m.state === 'no' ? 'no-fit' : 'unknown';
          var flag = m.state === 'fit' ? '✓' : m.state === 'no' ? '✕' : '?';
          var meta = m.state === 'unknown' ? (kind === 'doorway' ? 'Width not published — we’ll confirm it for you. ' : 'The maker doesn’t publish this — we’ll confirm it for you. ') + '<a href="' + esc(p.url) + '">Open the fit check</a>' : esc(m.note) + (m.state === 'fit' ? (kind === 'doorway' ? ' · <b>fits</b>' : ' · <b>suits you</b>') : '');
          html += '<div class="gcm ' + cls + '"><span class="gcm__flag" aria-hidden="true">' + flag + '</span>' +
            (p.img ? '<img class="gcm__img" src="' + esc(p.img) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="gcm__img"></span>') +
            '<span class="gcm__txt"><a class="gcm__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="gcm__meta">' + meta + '</span><span class="gcm__price">' + priceLine(p) + '</span></span>' +
            (m.state === 'no' ? '' : addBtn(p, true)) + '</div>';
        });
        html += '</div>';
      }
      html += '<p class="guide__calc-note">A guide only, not a clinical fitting. If you’re between sizes or unsure, send us the measurement — or ask an OT or physio to confirm.</p>';
      out.innerHTML = html;
    }
    range.addEventListener('input', function () { num.value = range.value; compute(); });
    num.addEventListener('input', function () { var v = parseFloat(num.value); if (!isNaN(v)) range.value = Math.min(+range.max, Math.max(+range.min, v)); compute(); });
    compute();
  });

  /* ------------------------------------------------------- compare sort */
  $$('[data-sort-table]').forEach(function (table) {
    var tbody = table.querySelector('tbody');
    var headers = $$('thead th[data-sort-key]', table);
    headers.forEach(function (th) {
      var label = th.textContent.trim();
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'gt-sort';
      btn.innerHTML = '<span>' + esc(label) + '</span><span class="sort-ar" aria-hidden="true"></span>';
      btn.setAttribute('aria-label', 'Sort by ' + label);
      th.textContent = ''; th.appendChild(btn); th.classList.add('is-sortable');
      btn.addEventListener('click', function () {
        var key = th.getAttribute('data-sort-key'), type = th.getAttribute('data-sort-type') || 'text';
        var dir = th.getAttribute('aria-sort') === 'ascending' ? 'descending' : 'ascending';
        headers.forEach(function (h) { h.removeAttribute('aria-sort'); });
        th.setAttribute('aria-sort', dir);
        var val = function (tr) { var c = tr.querySelector('[data-col="' + key + '"]'); if (!c) return ''; var v = c.getAttribute('data-sortval'); return v != null ? v : c.textContent.trim(); };
        var rows = $$('tr', tbody);
        rows.sort(function (a, b) {
          var av = val(a), bv = val(b);
          if (type === 'num') {
            var an = parseFloat(String(av).replace(/[^0-9.]/g, '')), bn = parseFloat(String(bv).replace(/[^0-9.]/g, ''));
            if (isNaN(an)) an = dir === 'ascending' ? Infinity : -Infinity; if (isNaN(bn)) bn = dir === 'ascending' ? Infinity : -Infinity;
            return dir === 'ascending' ? an - bn : bn - an;
          }
          return dir === 'ascending' ? String(av).localeCompare(String(bv)) : String(bv).localeCompare(String(av));
        });
        rows.forEach(function (r) { tbody.appendChild(r); });
      });
    });
  });

  /* ----------------------------------------------------- jump to picks */
  $$('[data-jump]').forEach(function (j) {
    j.addEventListener('click', function (e) {
      var t = root.querySelector('[data-first-picks]') || root.querySelector('[data-section]');
      if (t) { e.preventDefault(); scrollToEl(t); }
    });
  });

  /* -------------------------------------------------- sticky mobile bar */
  var sticky = root.querySelector('[data-sticky-bar]');
  var hero = root.querySelector('[data-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('aw-guide-bar') === 'off'; } catch (e) {}
    var x = sticky.querySelector('[data-sticky-x]');
    if (x) x.addEventListener('click', function () { sticky.classList.remove('is-shown'); root.classList.remove('has-sticky'); dismissed = true; try { sessionStorage.setItem('aw-guide-bar', 'off'); } catch (e) {} });
    new IntersectionObserver(function (en) {
      var show = !dismissed && !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-shown', show); root.classList.toggle('has-sticky', show);
    }, { threshold: 0 }).observe(hero);
  }

  /* ===================================================================
     "Let us help you find it" — in-guide chooser
     =================================================================== */
  var ch = root.querySelector('[data-g-chooser]');
  if (!ch) return;
  var chBody = ch.querySelector('[data-gch-body]'), chFoot = ch.querySelector('[data-gch-foot]'), chTitle = ch.querySelector('[data-gch-title]');
  var chBar = ch.querySelector('[data-gch-progress] i'), chPanel = ch.querySelector('.gch__panel');
  var CFG = null, cfgP = null, Q = [], ans = {}, cur = 0, col = '', lastFocus = null;
  var COLL_NAMES = { 'rollators-walkers': 'rollators & seat walkers', 'walking-frames': 'walking frames', 'walking-sticks-crutches': 'walking sticks & crutches', 'manual-wheelchairs': 'manual wheelchairs' };
  var SUPPORT_COL = { little: 'walking-sticks-crutches', steady: 'walking-frames', seat: 'rollators-walkers' };

  function loadCfg() {
    if (CFG) return Promise.resolve(CFG);
    if (!cfgP) cfgP = fetch(ch.getAttribute('data-config'), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (j) { CFG = j; return j; });
    return cfgP;
  }
  function family(c) {
    var fams = CFG.families || [];
    for (var i = 0; i < fams.length; i++) { var m = fams[i].match || {}; if (m.handles && m.handles.indexOf(c) > -1) return fams[i]; }
    for (var k = 0; k < fams.length; k++) if ((fams[k].match || {}).always) return fams[k];
    return null;
  }
  function expand(f) {
    return (f && f.questions || []).map(function (q) {
      var o = q.options;
      if (q.weight) o = CFG.weightOptions; else if (q.budget) o = CFG.budgetOptions;
      return { id: q.id, title: q.title, hint: q.hint, soft: !!q.soft || !!q.weight || !!q.budget, weight: !!q.weight, options: o || [] };
    }).filter(function (q) { return q.options.length; });
  }

  /* rule evaluator (tri-state: true pass, false fail, null unknown) — mirrors the chooser's rule names */
  function hay(p) { return [p.title, p.type, (p.tags || []).join(' ')].join(' '); }
  function ev(r, p) {
    if (!r) return true;
    var f = p.fit || {}, k, res, unk;
    if (r.any) { unk = false; for (k = 0; k < r.any.length; k++) { res = ev(r.any[k], p); if (res === true) return true; if (res === null) unk = true; } return unk ? null : false; }
    if (r.all) { unk = false; for (k = 0; k < r.all.length; k++) { res = ev(r.all[k], p); if (res === false) return false; if (res === null) unk = true; } return unk ? null : true; }
    if (r.not) { res = ev(r.not, p); return res === null ? null : !res; }
    if (r.re != null) { if (r.re === '') return true; try { return new RegExp(r.re, 'i').test(hay(p)); } catch (e) { return null; } }
    if (r.tag) return (p.tags || []).indexOf(r.tag) > -1;
    if (r.tagAny) return r.tagAny.some(function (t) { return (p.tags || []).indexOf(t) > -1; });
    if (r.type) return p.type === r.type;
    if (r.typeRe) { try { return new RegExp(r.typeRe, 'i').test(p.type || ''); } catch (e) { return null; } }
    if (r.weightMin != null) { var w = f.max_user_weight_kg; return w ? w >= r.weightMin : null; }
    if (r.priceMin != null || r.priceMax != null) { var pr = p.price / 100; if (r.priceMin != null && pr < r.priceMin) return false; if (r.priceMax != null && pr > r.priceMax) return false; return true; }
    if (r.widthMax != null) return f.overall_width_cm != null ? f.overall_width_cm <= r.widthMax : null;
    if (r.fit) { var v = f[r.fit.key]; if (v == null) return null; if (r.fit.eq != null) return v === r.fit.eq; if (r.fit.min != null && v < r.fit.min) return false; if (r.fit.max != null && v > r.fit.max) return false; return true; }
    return null;
  }
  function score(p) {
    var s = 0, out = false, why = [];
    Q.forEach(function (q) {
      var sel = ans[q.id]; if (!sel || !sel.length) return;
      var best = false;
      sel.forEach(function (oid) { var o = q.options.filter(function (x) { return x.id === oid; })[0]; if (!o) return; var r = ev(o.test, p); if (r === true) best = true; else if (r === null && best !== true) best = null; });
      if (best === true) { s += q.soft ? 1 : 2; }
      else if (best === false) { if (q.soft) s -= 1; else out = true; }
      else if (q.weight) why.push('weight rating');
      else if (!q.soft) why.push(String(q.title).toLowerCase().replace(/[?]$/, ''));
    });
    return { s: s, out: out, confirm: why };
  }
  function nAns() { return Q.filter(function (q) { return ans[q.id] && ans[q.id].length; }).length; }
  function targetCol() {
    if (ans.support && ans.support.length === 1 && SUPPORT_COL[ans.support[0]]) return SUPPORT_COL[ans.support[0]];
    return col;
  }
  function hmcUrl() {
    var parts = Q.filter(function (q) { return ans[q.id] && ans[q.id].length; }).map(function (q) { return q.id + '.' + ans[q.id].join('+'); });
    return '/collections/' + targetCol() + (parts.length ? '?hmc=' + encodeURIComponent(parts.join(',')).replace(/%2C/g, ',').replace(/%2B/g, '+').replace(/%2E/g, '.') : '');
  }

  function renderQ() {
    var q = Q[cur];
    if (chBar) chBar.style.transform = 'scaleX(' + ((cur) / Q.length).toFixed(3) + ')';
    var sel = ans[q.id] || [];
    var h = '<p class="gch__step">Question ' + (cur + 1) + ' of ' + Q.length + '</p>';
    h += '<h3 class="gch__q" id="gch-q">' + esc(q.title) + '</h3>';
    if (q.hint) h += '<p class="gch__hint">' + esc(q.hint) + '</p>';
    h += '<div class="gch__opts" role="group" aria-labelledby="gch-q">';
    q.options.forEach(function (o) {
      var on = sel.indexOf(o.id) > -1;
      h += '<button type="button" class="gch__opt' + (on ? ' is-on' : '') + '" data-opt="' + esc(o.id) + '" aria-pressed="' + on + '"><b>' + esc(o.label) + '</b>' + (o.sub ? '<small>' + esc(o.sub) + '</small>' : '') + '</button>';
    });
    h += '</div>';
    chBody.innerHTML = h;
    chFoot.innerHTML = '<div class="gch__nav">' +
      (cur > 0 ? '<button type="button" class="gch__link" data-gch-back>← Back</button>' : '<span></span>') +
      '<button type="button" class="gch__link" data-gch-skip>' + (cur < Q.length - 1 ? 'Skip' : 'Skip to results') + '</button></div>' +
      '<button type="button" class="g-btn g-btn--red gch__results" data-gch-done' + (nAns() ? '' : ' disabled') + '>Show my shortlist</button>';
    var first = chBody.querySelector('.gch__opt.is-on') || chBody.querySelector('.gch__opt');
    if (first) first.focus({ preventScroll: true });
  }
  function renderResults() {
    if (chBar) chBar.style.transform = 'scaleX(1)';
    var res = PLIST.map(function (p) { var r = score(p); return { p: p, r: r }; }).filter(function (x) { return !x.r.out; });
    res.sort(function (a, b) { return (a.r.confirm.length ? 1 : 0) - (b.r.confirm.length ? 1 : 0) || (b.r.s - a.r.s) || ((b.p.available ? 1 : 0) - (a.p.available ? 1 : 0)) || (a.p.price - b.p.price); });
    var tc = targetCol(), cname = COLL_NAMES[tc] || 'the range';
    var h = '<p class="gch__step">Your shortlist</p>';
    if (res.length) {
      var nSure = res.filter(function (x) { return !x.r.confirm.length; }).length, nMaybe = res.length - nSure;
      h += '<h3 class="gch__q">' + (nSure ? (nSure === 1 ? 'One model in this guide clearly suits your answers' : nSure + ' models in this guide clearly suit your answers') + (nMaybe ? ', plus ' + nMaybe + ' we’d need to confirm' : '') : 'These might suit — we’ll confirm the details for you') + '</h3>';
      if (res.length > 5) h += '<p class="gch__hint">Showing the closest 5.</p>';
      h += '<div class="gch__list">';
      res.slice(0, 5).forEach(function (x, i) {
        var p = x.p;
        h += '<div class="gcm gch__item' + (i === 0 && !x.r.confirm.length ? ' is-top' : '') + '">' +
          (p.img ? '<img class="gcm__img" src="' + esc(p.img) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="gcm__img"></span>') +
          '<span class="gcm__txt">' + (i === 0 && !x.r.confirm.length ? '<span class="gch__badge">Closest match</span>' : '') + '<a class="gcm__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="gcm__price">' + priceLine(p) + '</span>' +
          (x.r.confirm.length ? '<span class="gcm__meta">Not confirmed in the listing: ' + esc(x.r.confirm.join(', ')) + ' — we’ll check for you</span>' : '') +
          (!p.available ? '<span class="gcm__meta">Currently out of stock</span>' : '') + '</span>' + addBtn(p, true) + '</div>';
      });
      h += '</div>';
    } else {
      h += '<h3 class="gch__q">Nothing in this guide fits every answer</h3><p class="gch__hint">That’s not unusual — the full range is much bigger than the handful I’ve reviewed here. See every match below, or call us and we’ll find one.</p>';
    }
    chBody.innerHTML = h;
    chFoot.innerHTML = '<a class="g-btn g-btn--red gch__results" href="' + esc(hmcUrl()) + '">See every match in ' + esc(cname) + ' →</a>' +
      '<div class="gch__nav"><button type="button" class="gch__link" data-gch-restart>Start over</button><a class="gch__link" href="tel:+61291254293">Or call (02) 9125 4293</a></div>';
    var f = chFoot.querySelector('a'); if (f) f.focus({ preventScroll: true });
  }

  function lock(on) { document.documentElement.classList.toggle('gch-lock', on); }
  function openCh(c, opener) {
    col = c || root.getAttribute('data-collection') || '';
    lastFocus = opener || document.activeElement;
    ch.hidden = false; void ch.offsetWidth; ch.classList.add('is-open'); lock(true);
    chBody.innerHTML = '<p class="gch__q">Loading questions…</p>'; chFoot.innerHTML = '';
    loadCfg().then(function () {
      var f = family(col);
      var nextQ = expand(f);
      if (JSON.stringify(nextQ.map(function (q) { return q.id; })) !== JSON.stringify(Q.map(function (q) { return q.id; }))) { ans = {}; cur = 0; }
      Q = nextQ;
      if (chTitle) chTitle.textContent = 'Help me choose · ' + (COLL_NAMES[col] ? COLL_NAMES[col].charAt(0).toUpperCase() + COLL_NAMES[col].slice(1) : (f && f.label) || 'this range');
      if (!Q.length) { location.href = '/collections/' + col; return; }
      if (cur >= Q.length) renderResults(); else renderQ();
    }).catch(function () {
      chBody.innerHTML = '<p class="gch__q">Sorry — the questions couldn’t load.</p><p class="gch__hint"><a href="/collections/' + esc(col) + '">Browse the range</a> or call <a href="tel:+61291254293">(02) 9125 4293</a>.</p>';
    });
    setTimeout(function () { if (chPanel) chPanel.focus({ preventScroll: true }); }, 30);
  }
  function closeCh() {
    ch.classList.remove('is-open'); lock(false);
    setTimeout(function () { ch.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-g-choose]');
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    openCh(t.getAttribute('data-collection'), t);
  });
  ch.addEventListener('click', function (e) {
    if (e.target.closest('[data-gch-close]')) { closeCh(); return; }
    var o = e.target.closest('[data-opt]');
    if (o) {
      var q = Q[cur], id = o.getAttribute('data-opt');
      ans[q.id] = (ans[q.id] || [])[0] === id ? [] : [id];
      if (ans[q.id].length && cur < Q.length - 1) { cur++; renderQ(); }
      else if (ans[q.id].length) { cur = Q.length; renderResults(); }
      else renderQ();
      return;
    }
    if (e.target.closest('[data-gch-back]')) { cur = Math.max(0, cur - 1); renderQ(); return; }
    if (e.target.closest('[data-gch-skip]')) { if (cur < Q.length - 1) { cur++; renderQ(); } else { cur = Q.length; renderResults(); } return; }
    if (e.target.closest('[data-gch-done]')) { cur = Q.length; renderResults(); return; }
    if (e.target.closest('[data-gch-restart]')) { ans = {}; cur = 0; renderQ(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!ch.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeCh(); return; }
    if (e.key === 'Tab') {
      var f = $$('a[href], button:not([disabled]), [tabindex="0"]', chPanel);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === chPanel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
